import { api } from 'services/api';

export class ProvidersServicePositivo {
  async getEtapas() {
    const { data } = await api.get(`/reportsPositivo/productionDepartmentPositivo/etapa`);
    return data;
  }

  async getProductionDepartmentReport(inputDate, outputDate, type, etapa) {
    return api.post(`/reportsPositivo/productionDepartmentPositivo`, {
      inputDate: inputDate,
      outputDate: outputDate,
      type: type,
      etapa: etapa,
    });
  }

  async getAtribuido(data) {
    return api.post(`/reports/productionDepartmentPositivoAtribuido`, data);
  }
}

export const providersServicePositivo = new ProvidersServicePositivo();
